import React, { useEffect } from 'react';
import { ApplicationState } from "../../redux/reducers";
import { connect } from "react-redux"
import { Button, Checkbox, Grid, TextField } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import { useState } from "react";
import { setUsuario } from "../../redux/actions/usuarioActions";
import { ChangeEvent } from "react";
import { enums } from "../../enums/enums";
import { Defaults } from "../../defaults/Defaults";
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import SubmitButton from '../controls/SubmitButton';
import { IUsuario } from "../../entities/catalogos/IUsuario";
import { ICotizacionHistorialDto } from '../../entities/cotizaciones/ICotizacionHistorialDto';
import useCommonApi from '../../api/useCommonApi';
import LoadingDialog from '../controls/LoadingDialog';
import { ISolicitud } from '../../entities/solicitudes/Solicitud';
import { ISolicitudServicioHistorialDto } from '../../entities/solicitudes/ISolicitudHistorialDto';
import { ICliente } from '../../entities/catalogos/ICliente';
import Help, { IHelp } from '../help/Help';
import { traducirButton, traducirLabel, traducirMessage } from  '../../blocks/traductor';



interface OwnProps {
    siguienteSeccion: (estatusId: number, solicitud: any, cotizacionId: any, contacto?: any) => void
    cotizacionId: number
}

interface StateProps {
    usuario: IUsuario
    solicitud: ISolicitud
    solicitudCopia: ISolicitud
    cliente: ICliente
    ayuda: IHelp
}


type Props = OwnProps & StateProps

const DatosCliente = ({ siguienteSeccion, usuario, cotizacionId, solicitud, cliente, solicitudCopia, ayuda }: Props) => {
    const [datosCliente, setDatosCliente] = useState<any>({ empresa: '', nombre: '', apellido: '', telefono: '', correo: '', esParticular: 0, tipoPersonaId: cliente.tipoPersonaID ? cliente.tipoPersonaID : 1  });
    const [showLoading, setLoading] = useState(false);
    const [disabledFields, setDisabledFields] = useState(false);


    useEffect(() => {

        if(!usuario.esInvitado){
        //if (cliente.id !== 0) {
            setDatosCliente({ correo: solicitudCopia.correo ? solicitudCopia.correo : solicitud.correo, empresa: cliente.nombre , nombre: cliente.nombre , telefono: cliente.telefono , tipoPersonaId: cliente.tipoPersonaID ? cliente.tipoPersonaID : 1 });
        }
        //else if (cliente.id == 0 && usuario.id == 0) {
        else if (usuario.esInvitado) {
            if(solicitudCopia.nombreInv !== undefined){
                setDatosCliente({ correo: solicitudCopia.correo, empresa: solicitudCopia.empresaTarifaAlmex , nombre: solicitudCopia.nombreInv, apellido: solicitudCopia.apellidoInv, telefono: solicitudCopia.telefonoTarifaAlmex, esParticular: solicitudCopia.esParticularTarifaAlmex, tipoPersonaId: solicitudCopia.esParticularTarifaAlmex });
            }
            else{
                setDatosCliente({ correo: '', empresa: '' , nombre: '', apellido: '', telefono: '', esParticular: 0, tipoPersonaId: cliente.tipoPersonaID });
            }
        }
        else{
            setDatosCliente({ correo: solicitudCopia.correo, empresa: solicitudCopia.empresaTarifaAlmex, nombre: solicitudCopia.nombreTarifaAlmex, telefono: solicitudCopia.telefonoTarifaAlmex, tipoPersonaId: solicitudCopia.esParticularTarifaAlmex == 0 ? 2 : 1 });
        }

        if(usuario.esInvitado)
            setDisabledFields(false);
            else
            setDisabledFields(true);


    }, []);

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;
        if (name === "esParticular") {
            let toogleChk = 0;
            if(datosCliente.esParticular === 0){
                toogleChk = 1;
            }
            else{
                toogleChk = 0;
            }
            setDatosCliente({ ...datosCliente, [name]: Number(toogleChk) });
        }
        if (name === "tipoPersonaId") {
            setDatosCliente({ ...datosCliente, [name]: Number(value) });
        } 
        if (name !== "esParticular" && name !== "tipoPersonaId") {
            setDatosCliente({ ...datosCliente, [name]: value.toUpperCase() });
        }
    };
    const apiSource = useCommonApi();
    const setCotizacionHistorialDto = (usuario): ICotizacionHistorialDto => {


        return {
            cotizacionID: cotizacionId,
            clienteID: 0,
            usuarioID: usuario.id,
            paisOrigenId: 0,
            estadoOrigenId: 0,
            ciudadOrigenId: 0,
            coloniaOrigenId: 0,
            codigoPostalOrigenId: 0,
            areaServicioOrigenId: 0,
            sucursalOrigenId: 0,
            tipoRecoleccionOrigenId: 0,
            fechaCitaOrigen: undefined,
            paisDestinoId: 0,
            estadoDestinoId: 0,
            ciudadDestinoId: 0,
            coloniaDestinoId: 0,
            codigoPostalDestinoId: 0,
            areaServicioDestinoId: 0,
            sucursalDestinoId: 0,
            tipoRecoleccionDestinoId: 0,
            fechaCitaDestino: undefined,
            tipoServicioId: 0,
            unidadMedidaLongitudId: 0,
            unidadMedidaPesoId: 0,
            esSeguroBasico: false,
            esSeguroDeclarado: false,
            valorMercancia: 0,
            markupMonto: 0,
            markupPorcentaje: 0,
            usuarioNombre: usuario.nombre,
            usuarioApellido: usuario.apellido,
            usuarioTelefono: usuario.telefono,
            usuarioCorreo: usuario.email,
            usuarioTipoId: usuario.tipoPersonaId,
            tipoEnvioId: 0,
            estatusId: 5,
            generoCotizacion: false
        };
    };

    const actualizarCotizacion = async (datosUsuario) => {
        const result = await apiSource.postAsync<number>("/cotizacion-historial/actualiza-cliente", setCotizacionHistorialDto(datosUsuario));
        return result;
    }


    const setSolicitudHistorialDto = (usuario): ISolicitudServicioHistorialDto => {


        return {
            solicitudID: cotizacionId,
            cotizacionID: 0,
            clienteID: 0,
            usuarioID: usuario.id,
            paisOrigenId: 0,
            estadoOrigenId: 0,
            ciudadOrigenId: 0,
            coloniaOrigenId: 0,
            codigoPostalOrigenId: 0,
            areaServicioOrigenId: 0,
            sucursalOrigenId: 0,
            tipoRecoleccionOrigenId: 0,
            fechaCitaOrigen: undefined,
            paisDestinoId: 0,
            estadoDestinoId: 0,
            ciudadDestinoId: 0,
            coloniaDestinoId: 0,
            codigoPostalDestinoId: 0,
            areaServicioDestinoId: 0,
            sucursalDestinoId: 0,
            tipoRecoleccionDestinoId: 0,
            fechaCitaDestino: undefined,
            tipoServicioID: 0,
            unidadMedidaLongitudId: 0,
            unidadMedidaPesoId: 0,
            esSeguroBasico: false,
            esSeguroDeclarado: false,
            valorMercancia: 0,
            markupMonto: 0,
            markupPorcentaje: 0,
            usuarioNombre: usuario.nombre,
            usuarioApellido: usuario.apellido,
            usuarioTelefono: usuario.telefono,
            usuarioCorreo: usuario.email,
            usuarioTipoId: usuario.tipoPersonaId,
            tipoEnvioId: 0,
            estatusId: 5,
            generoSolicitud: false
        };
    };

    const actualizarSolicitud = async (datosUsuario) => {
        setLoading(true);
        const result = await apiSource.postAsync<number>("/solicitud-historial/actualiza-cliente", setSolicitudHistorialDto(datosUsuario));
        if (result) {
            setLoading(false);
        }
        else {
            setLoading(false);
        }


    }

    const handleSiguienteSeccion = () => {
        if(usuario.esInvitado){
            siguienteSeccion(enums.estatusSolicitud.origenDestino, datosCliente, cotizacionId);
        }
        else{
            siguienteSeccion(enums.estatusSolicitud.tipoEnvio, datosCliente, cotizacionId);
        }
    };

    return (<>
        <Box display="flex" flexWrap="nowrap">
            <Box className="section-title">
                {/* Datos de Cliente o Datos de Contacto */
                !usuario.esInvitado ? traducirLabel(72) : traducirLabel(70)}
            </Box>
        </Box>


        <Box p={3}>

            <Help comments={traducirMessage(225)} customStyle={{ bottom: "20px", right: "0" }} />

            <ValidatorForm onSubmit={handleSiguienteSeccion}>
            {!usuario.esInvitado &&
                <Grid container spacing={4} >
                    <Grid item xs={11} md={6}>
                        <TextValidator
                            label={traducirLabel(204)} /*"Nombre Completo"*/
                            value={datosCliente.nombre}
                            name="nombre"
                            onChange={handleChange}
                            variant="filled"
                            fullWidth
                            validators={['required']}
                            disabled={disabledFields}
                            errorMessages={[traducirLabel(126)]}
                        />
                    </Grid>
                    {(datosCliente.tipoPersonaId == 2) &&

                        <Grid item xs={11} md={6}>
                            <TextValidator
                                label= {usuario.esInvitado ? traducirLabel(112) : traducirLabel(38)}
                                // "Empresa":"Cliente"
                                value={datosCliente.empresa}
                                name="empresa"
                                onChange={handleChange}
                                variant="filled"
                                disabled={disabledFields}
                                fullWidth
                                errorMessages={[traducirLabel(126)]}
                            />
                        </Grid>
                    }
                    {datosCliente.tipoPersonaId == 1 &&
                        <Grid item xs={11} md={6}></Grid>
                    }



                    <Grid item xs={11} md={6}>
                        <TextValidator
                            label={traducirLabel(290)} /*"Teléfono"*/
                            value={datosCliente.telefono}
                            name="telefono"
                            onChange={handleChange}
                            variant="filled"
                            fullWidth
                            disabled={disabledFields}
                            validators={['required', 'isNumber' ]}
                            InputProps={{
                                inputProps: { maxLength:15},
                            }}
                            errorMessages={[traducirLabel(126),traducirLabel(293)]}
                        />
                    </Grid>

                    <Grid item xs={11} md={6}>
                        <TextValidator
                            label={traducirLabel(54)} /*"Correo"*/
                            value={datosCliente.correo}
                            name="correo"
                            onChange={handleChange}
                            variant="filled"
                            fullWidth
                            validators={['required', 'isEmail']}
                            errorMessages={[traducirLabel(126), traducirLabel(55)]}
                        />
                    </Grid>

                    {/* { solicitudCopia.tipoSolicitud == 'cotizacion' &&
                    <Grid item xs={11} sm={12}>
                        <FormControl component="fieldset">
                            <FormLabel component="legend">Tipo</FormLabel>
                            <RadioGroup row name="tipoPersonaId" value={datosCliente.tipoPersonaId} onChange={handleChange}>
                                <FormControlLabel value={enums.tipoPersona.particular} label="Particular"
                                    control={<Radio color="primary" size="small" />} />
                                <FormControlLabel value={enums.tipoPersona.empresa} label="Empresa"
                                    control={<Radio color="primary" size="small" />} />
                            </RadioGroup>
                        </FormControl>
                    </Grid>
                    } */}
                </Grid>
            }
            {usuario.esInvitado &&
                <Grid container spacing={4} >
                    <Grid item xs={11} md={6}>
                        <TextValidator
                            label={traducirLabel(201)} /*"Nombre"*/
                            value={datosCliente.nombre}
                            name="nombre"
                            onChange={handleChange}
                            variant="filled"
                            fullWidth
                            validators={['required']}
                            disabled={disabledFields}
                            errorMessages={[traducirLabel(126)]}
                        />
                    </Grid>
                    <Grid item xs={11} md={6}>
                        <TextValidator
                            label={traducirLabel(17)} /*Apellido"*/
                            value={datosCliente.apellido}
                            name="apellido"
                            onChange={handleChange}
                            variant="filled"
                            fullWidth
                            validators={['required']}
                            disabled={disabledFields}
                            errorMessages={[traducirLabel(126)]}
                        />
                    </Grid>
                    <Grid item xs={11} md={6}>
                        <TextValidator
                            label={traducirLabel(290)} /*"Teléfono"*/
                            value={datosCliente.telefono}
                            name="telefono"
                            onChange={handleChange}
                            variant="filled"
                            fullWidth
                            disabled={disabledFields}
                            validators={['required', 'isNumber' ]}
                            InputProps={{
                                inputProps: { maxLength:15},
                            }}
                            errorMessages={[traducirLabel(126),traducirLabel(293)]}
                        />
                    </Grid>
                    {(datosCliente.tipoPersonaId == 2 || usuario.esInvitado) &&

                    <Grid item xs={11} md={6}>
                        <TextValidator
                            label= {usuario.esInvitado ? traducirLabel(112) : traducirLabel(38)}
                            // "Empresa":"Cliente"
                            value={datosCliente.empresa}
                            name="empresa"
                            onChange={handleChange}
                            variant="filled"
                            disabled={disabledFields}
                            fullWidth
                            validators={['required']}
                            errorMessages={[traducirLabel(126)]}
                        />
                    </Grid>
                    }
                    {(datosCliente.tipoPersonaId == 1 && !usuario.esInvitado) &&
                    <Grid item xs={11} md={6}></Grid>
                    }
                    <Grid item xs={11} md={6}>
                        <TextValidator
                            label={traducirLabel(54)} /*"Correo"*/
                            value={datosCliente.correo}
                            name="correo"
                            onChange={handleChange}
                            variant="filled"
                            fullWidth
                            validators={['required', 'isEmail']}
                            errorMessages={[traducirLabel(126), traducirLabel(55)]}
                        />
                    </Grid>
                    <Grid item xs={11} md={6}>
                        <span >
                            {/* Es Particular */ traducirLabel(341)}
                        </span>
                        <Checkbox name="esParticular" color="primary" size="small" checked={datosCliente.esParticular}
                            onChange={handleChange} />
                    </Grid>

                    {/* { solicitudCopia.tipoSolicitud == 'cotizacion' &&
                    <Grid item xs={11} sm={12}>
                        <FormControl component="fieldset">
                            <FormLabel component="legend">Tipo</FormLabel>
                            <RadioGroup row name="tipoPersonaId" value={datosCliente.tipoPersonaId} onChange={handleChange}>
                                <FormControlLabel value={enums.tipoPersona.particular} label="Particular"
                                    control={<Radio color="primary" size="small" />} />
                                <FormControlLabel value={enums.tipoPersona.empresa} label="Empresa"
                                    control={<Radio color="primary" size="small" />} />
                            </RadioGroup>
                        </FormControl>
                    </Grid>
                    } */}
                </Grid>
            }
                <SubmitButton />
            </ValidatorForm>



        </Box>

        {showLoading &&
        // Procesando
            <> <LoadingDialog titulo={traducirLabel(240)} abierto={true} /></>
        }
    </>)
};

const mapStateToProps = (state: ApplicationState) => ({
    usuario: state.usuario,
    cliente: state.cliente,
    solicitud: state.solicitud,
    solicitudCopia: state.solicitudCopia,
    ayuda: state.ayuda
});

const mapDispatchToProps = {
    setUsuario: setUsuario
};

export default connect(mapStateToProps, mapDispatchToProps)(DatosCliente);
